import { Leaf } from "lucide-react";
import React from "react";
import { Card, CardContent } from "../ui/common/card";

interface ProductInfoCardProps {
  productImage?: string;
  productName?: string;
  /** Muted subtitle under the name — e.g. the supplier name for an ingredient. */
  productSubtitle?: string;
  calculatedDate: string;
  isAverageProduct: boolean;
  /** Roomier padding for the tab-in-modal contexts (product/ingredient details). */
  compact?: boolean;
}

/**
 * Shared "Environmental Footprint" product/ingredient info card — used by the
 * Product Summary page and the Product/Ingredient details modals'
 * Environmental Footprint tabs. `compact` switches to the roomier padding
 * those modal tabs use versus the Product Summary page's tighter default.
 */
const ProductInfoCard: React.FC<ProductInfoCardProps> = ({
  productImage,
  productName,
  productSubtitle,
  calculatedDate,
  isAverageProduct,
  compact
}) => {
  return (
    <Card className="tw-border-border tw-rounded-lg">
      <CardContent
        className={`${compact ? "tw-p-2" : "tw-p-1"} tw-flex tw-flex-col tw-items-center tw-text-center tw-h-full tw-justify-center`}
      >
        {!isAverageProduct && (
          <>
            <p className="tw-text-xs tw-text-muted-foreground tw-mb-1">Calculated on</p>
            <p className="tw-text-xs tw-text-foreground tw-bg-muted tw-px-3.5 tw-py-1.5 tw-rounded-md tw-mb-4">
              {calculatedDate}
            </p>
          </>
        )}
        {productImage ? (
          <img
            src={productImage}
            alt={productName || "Product"}
            width={100}
            height={100}
            className="tw-mb-1.5 tw-h-[100px] tw-w-[100px] tw-rounded-full tw-object-cover"
          />
        ) : (
          <div className="tw-mb-1.5 tw-flex tw-h-[100px] tw-w-[100px] tw-items-center tw-justify-center tw-rounded-full tw-bg-primary/10">
            <Leaf className="tw-h-10 tw-w-10 tw-text-primary" />
          </div>
        )}
        <p className="tw-text-sm tw-font-medium tw-text-foreground">{productName}</p>
        {productSubtitle ? (
          <p className="tw-text-xs tw-text-muted-foreground">{productSubtitle}</p>
        ) : null}
      </CardContent>
    </Card>
  );
};

export default ProductInfoCard;
